export default "__VITE_ASSET__DNCIpbw0__"